// Project 7: 팩트 체크 서비스
import axios from 'axios';
import type { FactCheckRequest, FactCheckResponse } from '@/types/factCheck';

const apiClient = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export class FactCheckService {
  /**
   * 팩트 체크 수행
   */
  async checkFacts(request: FactCheckRequest): Promise<FactCheckResponse> {
    try {
      const response = await apiClient.post<FactCheckResponse>(
        '/v2/content/fact-check',
        request
      );

      if (!response.data.success) {
        throw new Error(response.data.error?.message || '팩트 체크에 실패했습니다.');
      }

      return response.data;
    } catch (error: any) {
      console.error('Fact check error:', error);
      return {
        success: false,
        error: {
          code: error.response?.data?.error?.code || 'FACT_CHECK_FAILED',
          message: error.response?.data?.error?.message || error.message || '팩트 체크에 실패했습니다.',
        },
      };
    }
  }
}

export const factCheckService = new FactCheckService();

